export const randomItem = (items: string[] | null) => {
  if (!items) return
  const random = Math.round(Math.random() * (items.length - 1))
  return items[random]
}